// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.08 5.36L6.99 2.65C7.62 2.3 8.38 2.3 9.01 2.65L13.93 5.36C14.69 5.78 14.69 6.42 13.93 6.84L9.01 9.55C8.38 9.9 7.62 9.9 6.99 9.55L2.08 6.84C1.31 6.42 1.31 5.78 2.08 5.36Z',
  'M3.6 7.68V10.05C3.6 11.6 5.64 12.7 8 12.7C10.36 12.7 12.4 11.6 12.4 10.05V7.68',
  'M14.5 6.1V10.4',
];
